import parse from "date-fns/parse";
import { z } from "zod";

const DEFAULT_INVALID_MESSAGE = "please enter a valid date";

const dateFromString = (message: string = DEFAULT_INVALID_MESSAGE) =>
	z.preprocess(
		(value) => {
			if (value instanceof Date) return value;
			if (typeof value === "string") {
				const parsed = parse(value, "dd.MM.yyyy", new Date());
				return Number.isNaN(parsed.getTime()) ? value : parsed;
			}
			return value;
		},
		z.date({
			required_error: message,
			invalid_type_error: message,
		}),
	);

export { dateFromString };
